export interface HMPageConfig {
  path: string;
  metadata?: {
    title: string;
  };
  /**
   * `full-height`: the page fills the room under the top bar and scrolls itself, as the chat does to keep its
   * message box at the bottom. Other pages scroll inside the layout's padded column.
   */
  layout?: 'full-height';
}

// Every route mounted under PortalLayout needs an entry here: its title
// drives the breadcrumb and document title. A route missing here falls back
// to "Finlay" for both.
export const hmPages: HMPageConfig[] = [
  {
    path: '/hm',
    metadata: {
      title: 'Jobs',
    },
  },
  {
    path: '/hm/chat/:conversationId?',
    metadata: {
      title: 'Chat',
    },
    layout: 'full-height',
  },
  {
    path: '/hm/jobs/:jobId/edit',
    metadata: {
      title: 'Edit job',
    },
  },
  {
    path: '/hm/jobs/:jobId/candidates',
    metadata: {
      title: 'Candidates',
    },
  },
  {
    path: '/hm/jobs/:jobId/automation',
    metadata: {
      title: 'Automation',
    },
  },
  {
    path: '/hm/jobs/:jobId/candidates/:candidateId',
    metadata: {
      title: 'Candidate',
    },
  },
  {
    path: '/hm/slack-connect/:status',
    metadata: {
      title: 'Connect Slack',
    },
  },
  {
    path: '/hm/integrations',
    metadata: {
      title: 'Integrations',
    },
  },
  {
    path: '/hm/availability',
    metadata: {
      title: 'Availability',
    },
  },
  {
    path: '/hm/workspace',
    metadata: {
      title: 'Workspace',
    },
  },
  {
    path: '/hm/billing',
    metadata: {
      title: 'Billing',
    },
  },
  {
    path: '/hm/interviews',
    metadata: {
      title: 'Interviews',
    },
  },
  {
    path: '/hm/messages',
    metadata: {
      title: 'Outreach',
    },
  },
];

export const hmRoutes = hmPages.map((page) => ({
  path: page.path,
}));
